import {ValueObject} from '@s-ui/domain'

import {InvalidParamsSharedError} from '../../shared/Errors/InvalidParamsSharedError.js'
import {StringSharedValueObject} from '../../shared/ValueObjects/StringSharedValueObject.js'

export class GetSearchRequestFromAISearchRequest extends ValueObject {
  #listingSectionId
  #query

  constructor({listingSectionId, query}) {
    super()
    this.#listingSectionId = listingSectionId
    this.#query = query
  }

  static validate({query}) {
    if (!query)
      throw InvalidParamsSharedError.create(`[GetSearchRequestFromAISearchRequest.validate] query param is required`)
  }

  static createFromSearch({config, listingSectionId, query}) {
    GetSearchRequestFromAISearchRequest.validate({query})
    return new GetSearchRequestFromAISearchRequest({
      listingSectionId: StringSharedValueObject.create({config, value: listingSectionId}),
      query: StringSharedValueObject.create({config, value: query})
    })
  }

  get listingSectionId() {
    return this.#listingSectionId.value
  }

  get query() {
    return this.#query.value
  }

  get value() {
    return {
      listingSectionId: this.#listingSectionId.value,
      query: this.#query.value
    }
  }
}
